import { Dialog, DialogContent } from "@/components/ui/dialog";
import { getPublicFileUrl } from "@/lib/api";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { getEffectivePricingDisplay } from "@/lib/pricingUtils";
import CategoryPlaceholder from "./CategoryPlaceholder";
import { LANDING } from "@/constants/testIds";

export default function TreatmentDetailModal({ service, gallery = [], onClose, onBook }) {
  const { t } = usePublicLang();
  if (!service) return null;
  const pricing = getEffectivePricingDisplay(service);
  const serviceGallery = gallery.filter((g) => g.service_id === service.id);

  return (
    <Dialog open={Boolean(service)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl p-0 overflow-hidden rounded-2xl" data-testid={LANDING.treatmentDetailModal}>
        <div className="aspect-[16/9]">
          {service.photo_url ? (
            <img src={getPublicFileUrl(service.photo_url)} alt={service.name} className="w-full h-full object-cover" />
          ) : (
            <CategoryPlaceholder category={service.category} name={service.name} />
          )}
        </div>
        <div className="p-6 sm:p-8 flex flex-col gap-4 max-h-[50vh] overflow-y-auto">
          {service.category && <p className="text-xs uppercase tracking-[0.15em] font-medium text-[var(--brand-primary)]">{service.category}</p>}
          <h3 className="font-serif text-2xl sm:text-3xl text-[#292522]">{service.name}</h3>
          {service.description && <p className="text-base leading-relaxed text-[#6B6058] whitespace-pre-line">{service.description}</p>}
          {serviceGallery.length > 0 && (
            <div className="grid grid-cols-3 gap-2" data-testid={LANDING.treatmentGalleryPreview}>
              {serviceGallery.slice(0, 3).map((g) => (
                <div key={g.id} className="aspect-square rounded-lg overflow-hidden bg-muted">
                  {g.media_type === "video" ? (
                    <video src={getPublicFileUrl(g.image_url)} className="w-full h-full object-cover" muted />
                  ) : (
                    <img src={getPublicFileUrl(g.image_url || g.before_url)} alt="resultado" className="w-full h-full object-cover" />
                  )}
                </div>
              ))}
            </div>
          )}
          <div className="flex items-center justify-between gap-4 pt-2 border-t border-[rgba(140,125,112,0.15)]">
            <div className="flex items-center gap-2 text-sm">
              {pricing.isPromoActive ? (
                <>
                  <span className="line-through text-[#A89582]">{pricing.regularText}</span>
                  <span className="font-medium text-[var(--brand-primary)]">{pricing.promoText}</span>
                </>
              ) : (
                <span className="font-medium text-[var(--brand-primary)]">{pricing.regularText}</span>
              )}
            </div>
            <button
              type="button"
              onClick={() => onBook(service)}
              className="bg-[var(--brand-primary)] text-white text-sm font-medium px-6 py-2.5 rounded-full hover:opacity-90 active:scale-95 transition-all shrink-0"
              data-testid={LANDING.treatmentDetailBookButton}
            >
              {t("landing.treatments.ctaBook")}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
